import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';

import { isEmptyValue } from '@helpers';
import { HttpWrapper } from './http-wrapper.interface';
// Onderstaande expliciete pad @modals/... niet reduceren i.v.m. mogelijke cyclische import
import { EcertConfirmModalComponent, NEGATIVE_BTN, POSITIVE_BTN } from '@modals/ecertnl-confirm-modal/ecertnl-confirm-modal.component';

const MINUUT = 60 * 1000;

export class ApiSession {
  private sessieTimeoutInMinuten = 6;
  private sessieEindeVoorwaarschuwingInMinuten = 4;
  setSessieTimeout(sessieTimeoutInMinuten = 5) {
    this.sessieTimeoutInMinuten = Math.max(5, sessieTimeoutInMinuten);
    this.sessieEindeVoorwaarschuwingInMinuten = Math.max(this.sessieTimeoutInMinuten * (3 / 4), this.sessieTimeoutInMinuten - 5);
    this.restartSessieTimeout();
  }

  private authenticatieUrl: string;

  private sessieBijnaVerlopenTimer = null;
  private sessieBijnaVerlopenDialoog: MatDialogRef<EcertConfirmModalComponent, string> = null;
  private sessieVerlopenTimer = null;
  private sessieVerlopenDialoog: MatDialogRef<EcertConfirmModalComponent, string> = null;

  private subscriptions: Subscription[] = [];

  constructor(private dialog: MatDialog, private wrapper: HttpWrapper, private contextRoot: string) {}

  onInit(): void {
/*
    this.subscriptions.push(
      this.wrapper.get<string>(this.contextRoot + '/authenticatieUrl').subscribe((authenticatieUrl: string) => {
        this.authenticatieUrl = authenticatieUrl;
      })
    );
*/
  }

  onDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  restartSessieTimeout(): void {
/*
    this.stopAlleTimers();
    this.sessieBijnaVerlopenTimer = setTimeout(
      () => this.toonSessieBijnaVerlopenDialoog(),
      this.sessieEindeVoorwaarschuwingInMinuten * MINUUT
    );
*/
  }

  uitloggen(urlBestemming: string = null): void {
/*
    this.subscriptions.push(
      this.wrapper.post<null, string>(this.contextRoot + '/uitloggen', null).subscribe(() => {
        window.location.href = isEmptyValue(urlBestemming) ? this.authenticatieUrl : urlBestemming;
      })
    );
*/
  }

  verkeerdeSectorDialoog() {
/*
    const dialogRef = this.dialog.open(EcertConfirmModalComponent, {
      width: '500px',
      disableClose: true,
      data: {
        positiveButton: 'VERKEERDE_SECTOR.MELDING_POSITIVE_BTN',
        negativeButton: null,
        headerText: 'VERKEERDE_SECTOR.MELDING_HEADER',
        messageText: 'VERKEERDE_SECTOR.MELDING_MESSAGE',
      },
    });

    this.subscriptions.push(dialogRef.afterClosed().subscribe(() => this.toonSessieVerlopenDialoog()));
*/
  }

  gebruikerIsUitgelogd(doorOnderhoud = false) {
/*
    this.stopAlleTimers();
    this.toonSessieVerlopenDialoog(doorOnderhoud);
*/
  }

  private toonSessieVerlopenDialoog(vanwegeOnderhoud = false): void {
/*
    if (isEmptyValue(this.sessieVerlopenDialoog)) {
      this.sessieVerlopenDialoog = {} as MatDialogRef<EcertConfirmModalComponent>; // voorkom dat er meerdere van deze boxen over elkaar heen komen als de volgende call ook blokkeert
      if (!isEmptyValue(this.sessieBijnaVerlopenDialoog)) {
        this.sessieBijnaVerlopenDialoog.close(NEGATIVE_BTN);
        this.sessieBijnaVerlopenDialoog = null;
      }
      this.subscriptions.push(
        this.wrapper.post<null, string>(this.contextRoot + '/uitloggen', null).subscribe((opnieuwLoginUrl) => {
          this.sessieVerlopenDialoog = this.dialog.open(EcertConfirmModalComponent, {
            width: '500px',
            disableClose: true,
            data: {
              positiveButton: 'SESSION_EXPIRED.LOG_IN_BTN',
              positiveButtonFallback: 'opnieuw inloggen',
              negativeButton: null,
              headerText: 'SESSION_EXPIRED.EXPIRED_HEADER_TEXT',
              headerTextFallback: 'sessie verlopen',
              messageText: vanwegeOnderhoud ? 'SESSION_EXPIRED.MAINTENANCE_MESSAGE_TEXT' : 'SESSION_EXPIRED.EXPIRED_MESSAGE_TEXT',
              messageTextFallback: vanwegeOnderhoud ? 'onderhoud in aantocht' : 'te lang geen aktie',
              messageTextParameters: { timeout: this.sessieTimeoutInMinuten.toString() },
            },
            backdropClass: 'modal-background-blurred',
          });

          this.subscriptions.push(
            this.sessieVerlopenDialoog.afterClosed().subscribe(() => {
              this.sessieVerlopenDialoog = null;
              window.location.href = opnieuwLoginUrl;
            })
          );
        })
      );
    }
*/
  }

  private toonSessieBijnaVerlopenDialoog() {
/*
    if (isEmptyValue(this.sessieBijnaVerlopenDialoog) && isEmptyValue(this.sessieVerlopenDialoog)) {
      this.sessieBijnaVerlopenDialoog = this.dialog.open(EcertConfirmModalComponent, {
        width: '500px',
        disableClose: true,
        data: {
          positiveButton: 'SESSION_EXPIRED.KEEP_ALIVE_BTN',
          negativeButton: null,
          headerText: 'SESSION_EXPIRED.ALMOST_EXPIRED_HEADER_TEXT',
          messageText: 'SESSION_EXPIRED.ALMOST_EXPIRED_MESSAGE_TEXT',
          messageTextParameters: { timeout: this.sessieTimeoutInMinuten.toString() },
        },
      });

      this.subscriptions.push(
        this.sessieBijnaVerlopenDialoog.afterOpened().subscribe(() => this.startSessieVerlopenTimer()),
        this.sessieBijnaVerlopenDialoog.afterClosed().subscribe((result) => {
          if (result === POSITIVE_BTN) {
            this.subscriptions.push(this.wrapper.post<null, void>(this.contextRoot + '/getApplicationProperties', null).subscribe()); // re-trigger api
          }
          this.sessieBijnaVerlopenDialoog = null;
        })
      );
    }
*/
  }

  private startSessieVerlopenTimer(): void {
/*
    this.stopAlleTimers();
    this.sessieVerlopenTimer = setTimeout(
      () => this.toonSessieVerlopenDialoog(),
      (this.sessieTimeoutInMinuten - this.sessieEindeVoorwaarschuwingInMinuten) * MINUUT
    );
*/
  }

  private stopAlleTimers(): void {
/*
    if (this.sessieBijnaVerlopenTimer !== null) {
      clearTimeout(this.sessieBijnaVerlopenTimer);
      this.sessieBijnaVerlopenTimer = null;
    }
    if (this.sessieVerlopenTimer !== null) {
      clearTimeout(this.sessieVerlopenTimer);
      this.sessieVerlopenTimer = null;
    }
*/
  }
}
